import React, { Component } from 'react'
import Links from './components/partials/Links_Container'

export default class Wrnch extends Component {
    render() {
        return (
            <section className="page-content" id="page-brackets">
                <Links />
                <div className="app_container" id="wr_container">
                    <p className="app-title">wrnch<span>2020 Redesign</span></p>
                    <div className="app-splash_container">
                        <img className="app-splash-1" src="/images/brackets/wr/i1.jpg"/>
                        <img className="app-splash-2" src="/images/brackets/wr/i2.jpg"/>
                        <img className="app-splash-3" src="/images/brackets/wr/i3.jpg"/>
                        
                    </div>
                    <p className="app-description">
                        Wrnch.ai is a machine learning company taking the latest in image recognition technology to create real-time human pose estimation. 
                        Using data exlusively from standard video formats, the technology is able to capture the pose data of multiple human elements.
                        With applications in sports, entertainment, and healthcare the startup has become the premiere research and development house in their field.
                        As they continue to grow, Wrnch aims to deliver a modern and well supported experience for the creative developers keen to use their 
                        technology in connecting people to the digital world.  
                    </p>
                    <div className="app-item app-meta">
                        <img src="/images/brackets/wr/i4.jpg"/>
                        <div>
                            <p>wrnch inc.</p>
                            <ul>
                                <li>Figma  GIMP</li>
                                <li>HTML5 CSS3 ES6 JQuery</li>
                                <li>Ruby on Rails SASS </li>
                            </ul>
                        </div>
                    </div>
                    <div className="app-item" id="wr-flow">
                        <img src="/images/brackets/wr/flow2.jpg"/>
                        <p>Wrnch wanted to focus towards improving their user experience to deliver smoother navigation, improved accessability to information,
                            and unity in the site branding. One example is the user signup and login page flow. The pathway required renewed navigation and encouraged developers
                            to continue to discover wrnch's inhouse techology.
                        </p>
                    </div>
                    <div className="app-item app-row" id="wr-logos">
                        <p>The diverse applications of wrnch's technology required a unique, intuitive, and communicative company identiy. The revitalization of
                            the brand was two-fold; reapproach the user experience as a whole to improve a developer productivity and to draw in new users discovering the software; 
                            rearchitect the front-end codebase to accomodate current and new design changes as well as incorporating new technologies into their platform.
                        </p>
                        <img src="/images/brackets/wr/style-guide.jpg" />
                    </div>
                    <div className="app-item" id="wr-legal">
                        <div className="grid-container">
                            <img className="grid-container_item-1" src="/images/brackets/wr/2.jpg" />
                            <img className="grid-container_item-2" src="/images/brackets/wr/3.jpg" />
                        </div>
                        <p>The redesign encompassed reorganization to the developer portal navigation, simplification of users information and preferences, more fluid login and sign up process,
                            and increased mobile responsiveness. To support the redesign the architecture was refactored to support component-based methodologies and additonal coding practises.
                        </p>
                    </div>
                </div>
            </section>
        )
    }
}
